module.exports = __webpack_public_path__ + "img/1234567898.0168eed5.png";